/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Configuration for a specific goal in a StackAdapt campaign
*/
export class V3StackAdaptGoal {
    /**
    * Type of the goal. One of 'AUDIO_COMPLETION_RATE', 'COST_PER_PAGE_START', 'CPA', 'CPC', 'CPCL', 'CPCV', 'CPE', 'CPI', 'CTR', 'ECPM', 'ENGAGEMENT_RATE', 'PAGE_START_RATE', 'ROAS', 'SCALE', 'UNIQUE_REACH', 'UNSET_GOAL_TYPE', 'VIDEO_COMPLETION_RATE', or 'VIEWABILITY'
    */
    'goalType'?: string;
    /**
    * Value of the goal. Can be any valid JSON value
    */
    'goalValue'?: string;
    /**
    * Maximum value for the goal
    */
    'goalMax'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "goalType",
            "baseName": "goalType",
            "type": "string",
            "format": ""
        },
        {
            "name": "goalValue",
            "baseName": "goalValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "goalMax",
            "baseName": "goalMax",
            "type": "number",
            "format": "float"
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptGoal.attributeTypeMap;
    }

    public constructor() {
    }
}

